module.exports = __webpack_public_path__ + "img/default-file-icon.77824881.svg";